
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { BellIcon } from '@heroicons/react/24/solid';
import DOMPurify from 'dompurify';

interface NotificationModalProps {
  title: string;
  message: string;
  onDismiss?: () => void;
}

const NotificationModal: React.FC<NotificationModalProps> = ({ 
  title, 
  message, 
  onDismiss 
}) => {
  const [isOpen, setIsOpen] = useState(true);

  // Sanitize HTML to prevent XSS attacks
  const sanitizedMessage = DOMPurify.sanitize(message, {
    ALLOWED_TAGS: ['br', 'ul', 'li', 'strong', 'b', 'em', 'i', 'p'],
    ALLOWED_ATTR: []
  });

  const handleDismiss = () => {
    setIsOpen(false);
    if (onDismiss) {
      onDismiss();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleDismiss}>
      <DialogContent className="sm:max-w-md bg-gradient-to-r from-blue-600 to-purple-600 text-white border rounded-md shadow-md">
        <DialogHeader className="text-center">
          <div className="flex justify-center mb-4">
            <BellIcon className="h-8 w-8 text-white" />
          </div>
          <DialogTitle className="text-xl font-semibold text-white text-center">
            {title}
          </DialogTitle>
          <DialogDescription 
            className="text-base leading-relaxed text-white/90 text-center"
            dangerouslySetInnerHTML={{ __html: sanitizedMessage }}
          />
        </DialogHeader>
        
        <div className="flex justify-center mt-6">
          <Button 
            variant="outline" 
            onClick={handleDismiss}
            className="bg-white/10 border-white/20 text-white hover:bg-white/20 hover:text-white"
          >
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NotificationModal;
